module.exports = __webpack_public_path__ + "media/auto_history/dodanie_wspolwlasciciela-7028f517.png";